import { Component } from '@angular/core';

@Component({
    selector: 'app-page500',
    templateUrl: './page500.component.html',
    styleUrls: ['./page500.component.scss'],
    standalone: false
})
export class Page500Component {

  constructor() { }

}
